import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { AuthService, AuthType } from "../../shared/services/auth.service";


export interface TopicType {
    TopicTypeName: any;
    TopicTypeId: string;
    RenderType: string;
    MakeTypeAsDivider: boolean;
    ShowInFilter: boolean;
    ShowInLibrary: boolean;
    SealedTemplate?: boolean;
}


@Injectable()
export class TopicTypeService {
    topicTypesCount: number = 0;

    constructor(
        private http: HttpClient,
        private authService: AuthService,
    ) { }

    addTopicType(topicType: TopicType, accessList: string): Observable<any> {
        const url = `api/Category/Type/Add`;
        const body = {
            TopicTypeName: topicType.TopicTypeName,
            ShowAsSegment: topicType.MakeTypeAsDivider,
            ShowInFilter: topicType.ShowInFilter,
            SealedTemplate: topicType.SealedTemplate,
            AccessListId: accessList,
            IsDefault: topicType.ShowInLibrary
        };

        const options = {
            headers: this.authService.buildAuthHeader(AuthType.Technadopt),
        };
        return this.http.post(url, body, options);
    }


    deleteTopicType(topicType: TopicType): Observable<any> {
        const url = `api/Category/Type/Delete`;
        const body = {
            TopicTypeId: topicType.TopicTypeId,
        };

        const options = {
            headers: this.authService.buildAuthHeader(AuthType.Technadopt),
        };
        return this.http.post(url, body, options);
    }

    updateTopicType(topicType: TopicType, accessList: string) {
        const url = `api/Category/Type/Update`;
        const body = {
            TopicTypeId: topicType.TopicTypeId,
            TopicTypeName: topicType.TopicTypeName,
            ShowAsSegment: topicType.MakeTypeAsDivider,
            ShowInFilter: topicType.ShowInFilter,
            SealedTemplate: topicType.SealedTemplate,
            AccessListId: accessList,
            IsDefault: topicType.ShowInLibrary
        };

        const options = {
            headers: this.authService.buildAuthHeader(AuthType.Technadopt),
        };
        return this.http.put(url, body, options);
    }

    getTopicTypes(accessList: string, allowSealedTemplates: boolean = true): Observable<TopicType[]> {
        const url = `api/Category/GetCategoryTypes`;
        let params = new HttpParams({
            fromObject: {
                accessListIds: accessList || "",
            },
        })
        const options = {
            headers: this.authService.buildAuthHeader(AuthType.Technadopt),
            params,
        };
        return this.http.get<any>(url, options).pipe(map((res) => {
            let topicTypes: TopicType[] = [];
            res?.TopicTypes.forEach(tt => {
                let topicType: any = {
                    TopicTypeName: tt.TopicTypeName,
                    TopicTypeId: tt.TopicTypeId,
                    RenderType: tt.RenderType,
                    MakeTypeAsDivider: tt.ShowAsSegment,
                    ShowInFilter: tt.ShowInFilter,
                    ShowInLibrary: tt.IsDefault,
                    SealedTemplate: tt.SealedTemplate,
                }
                topicTypes.push(topicType);
            });
            
            // Filter out sealed templates if not allowed
            if (!allowSealedTemplates) {
                topicTypes = topicTypes.filter(tt => !tt.SealedTemplate);
            }
            
            this.topicTypesCount = topicTypes.length;
            return topicTypes;
        }));
    }
}